/**
 * 底划线动效组件
 */
"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
interface HoverUnderlineProps {
  isActive: boolean;
  isExiting: boolean;
  uniqueKey: string;
  className?: string;
}
export function HoverUnderline(t0) {
  const $ = _c(11);
  const {
    isActive,
    isExiting,
    uniqueKey,
    className: t1
  } = t0;
  const className = t1 === undefined ? "absolute left-4 right-4 bottom-1 h-[1px] bg-black" : t1;
  let t2;
  if ($[0] !== className || $[1] !== isActive || $[2] !== uniqueKey) {
    t2 = isActive && <motion.div key={uniqueKey} className={className} initial={{
      scaleX: 0,
      transformOrigin: "left",
      opacity: 0.8
    }} animate={{
      scaleX: 1,
      opacity: 1
    }} transition={{
      scaleX: {
        duration: 0.2,
        ease: [0.25, 0.46, 0.45, 0.94]
      },
      opacity: {
        duration: 0.15,
        ease: "easeOut"
      }
    }} />;
    $[0] = className;
    $[1] = isActive;
    $[2] = uniqueKey;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className || $[5] !== isExiting || $[6] !== uniqueKey) {
    t3 = isExiting && <motion.div key={`${uniqueKey}-exit`} className={className} initial={{
      scaleX: 1,
      transformOrigin: "left",
      opacity: 1
    }} animate={{
      scaleX: 0,
      opacity: 0
    }} transition={{
      scaleX: {
        duration: 0.3,
        ease: [0.25, 0.46, 0.45, 0.94]
      },
      opacity: {
        duration: 0.2,
        ease: "easeIn"
      }
    }} />;
    $[4] = className;
    $[5] = isExiting;
    $[6] = uniqueKey;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}